import { render, staticRenderFns } from "./ball.vue?vue&type=template&id=8c0cab64&scoped=true"
import script from "./ball.vue?vue&type=script&lang=js"
export * from "./ball.vue?vue&type=script&lang=js"
import style0 from "./ball.vue?vue&type=style&index=0&id=8c0cab64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0cab64",
  null
  
)

export default component.exports